module.exports = __webpack_public_path__ + "img/_express.6f81f7b4.svg";